// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import 'vue-material/dist/vue-material.css'
import './../static/app.css'

import VueMaterial from 'vue-material'
import VueCookies from 'vue-cookie'
import VueSession from 'vue-session'
import router from "./router/index";
import AuthService from "./services/AuthService";
import LocalMessageService from "./services/LocalMessageService";

Vue.use(VueMaterial);

Vue.config.productionTip = false;
Vue.http.options.credentials = true;

Vue.http.interceptors.push(function(request, next) {

  next(function(response) {
    if(response.status === 401){
      AuthService.removeToken();
      LocalMessageService.setLocalMessage("Sua sessão expirou! Faça login novamente!")
      router.push({path: '/login'});
    }
  });
});

Vue.material.registerTheme('default', {
  primary: {
    color: 'teal',
    hue: '400',
    textColor: 'white'
  },
  accent: {
    color: 'teal',
    hue: 'A400'
  },
  warn: {
    color: 'red',
      hue: '400'
  },
  background: 'white'
});

Vue.material.inkRipple = true

new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js